// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maincontent-physical {
  display: flex;
  padding-bottom: 1.5rem;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex: 1 0;
  align-self: stretch;
}

.toppart {
  display: flex;
  padding: 1.5rem;
  padding-left: 2.5rem;
  align-items: flex-start;
  align-self: stretch;
}

.breadcrumb {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.3125rem;
}

.breadcrumb-element1 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
}

.element-text {
  color: var(--Grey-Grey-400, #bdbdbd);
  font-family: Inter;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0.01125rem;
}

.breadcrumb-element2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.625rem;
}

.overline {
  color: var(--Grey-Grey-400, #bdbdbd);
  font-family: Roboto;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0.009375rem;
}

.breadcrumb-element3 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
}

.element-text3 {
  color: var(--Grey-Grey-800, #424242);
  font-family: Inter;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0.01125rem;
}

.mainpart-physical {
  display: flex;
  padding: 0rem 1.5rem;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0;
  align-self: stretch;
}

.assessments {
  display: flex;
  padding-bottom: 12rem;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  flex: 1 0;
  align-self: stretch;
}

.frame-1 {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.bar-tab {
  display: flex;
  width: 10.5rem;
  height: 2.5rem;
  max-width: 11.8125rem;
  max-height: 3.5rem;
  padding: 0.75rem 1rem;
  justify-content: center;
  gap: 0.5rem;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Neutral-300, #cbd5e1);
  background: var(--Neutral-50, #f8fafc);
}

.bar-tab-text {
  color: var(--Neutral-700, #334155);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
}

.bar-tab-active {
  border-radius: 8px;
  border: 1px solid var(--Primary-300, #74e1b4);
  background: var(--Primary-50, #edfcf5);
}
.check-icon-inline {
  width: 16px;
  height: 32px;
  margin-right: 6px;
  vertical-align: middle;
}
.bar-tab-completed {
  border-radius: 8px;
  border: 1px solid var(--Primary-300, #74e1b4);
  background: var(--Primary-50, #edfcf5);
}

.frame-2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.title-main {
  color: var(--Neutral-950, #020618);
  text-align: center;
  font-family: Inter;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2rem;
}

.subtitle-main {
  color: var(--Neutral-700, #334155);
  text-align: center;
  font-family: Inter;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
}

.frame-3 {
  display: flex;
  align-items: center;
  border-radius: 0.5rem;
  background: #fff;
}

.physical-image {
  width: 41.625rem;
  height: 18.5rem;
}

.frame-4 {
  display: flex;
  padding: 0.125rem 0.625rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  border-radius: 9999px;
  border: 1px solid #042a20;
  background: #edfcf5;
}

.bedge-text {
  color: var(--Neutral-950, #020618);
  font-family: Inter;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
}

.frame-5 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}

.button-physical {
  display: flex;
  height: 2.625rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.25rem;
  border: 0.03125rem solid #0a5b42;
  background: linear-gradient(180deg, #0c8f63 0%, #0a7253 103.57%);
}

.button-physical:hover {
    width: 100%;
    background: linear-gradient(180deg, #09704e 0%, #074f39 103.57%);
}

.button-text {
  color: #f8fafc;
  text-align: center;
  font-family: var(--Label-Large-Font, Roboto);
  font-size: var(--Label-Large-Size, 0.875rem);
  font-style: normal;
  font-weight: 500;
  line-height: var(--Label-Large-Line-Height, 1.25rem);
  letter-spacing: var(--Label-Large-Tracking, 0.00625rem);
}

.button-arrow {
  width: 2rem;
  height: 2rem;
  aspect-ratio: 1/1;
}

@media (max-width: 1158px) {
  .breadcrumb {
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.25rem;
    padding: 0.5rem;
    text-align: center;
  }

  .breadcrumb-element1,
  .breadcrumb-element2,
  .breadcrumb-element3 {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
  }

  .element-text,
  .element-text3,
  .overline {
    font-size: 0.65rem;
    line-height: 1rem;
    white-space: nowrap;
  }

  .toppart {
    flex-direction: column;
    padding: 1rem;
    align-items: flex-start;
    text-align: center;
  }

  .frame-3 {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem;
  }

  .physical-image {
    width: 100%;
    height: auto;
    max-width: 100%;
    object-fit: contain;
  }

  .mainpart-physical,
  .assessments,
  .frame-1,
  .frame-2,
  .frame-4,
  .frame-5 {
    padding: 0 1rem;
    align-items: center;
    text-align: center;
  }

  .title-main {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .subtitle-main {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .bar-tag {
    width: auto;
    padding: 0.5rem 1rem;
  }

  .button-physical {
    width: 100%;
    max-width: 300px;
  }
}

@media (max-width: 480px) {
  .bedge-text{
    font-size: 0.6rem;
  }
  .frame-1{
    display: none;
  }
  .frame-2{
    width:95vw;
    padding-top: 1rem;
    margin-left: 0.5rem;
  }
  .assessments{
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
  }
  .Report-frame-3{
    width: 100vw;
    display: flex;
    flex-direction: column;
    padding-right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/maincontent-physical/maincontent-physical.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,SAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,SAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,gEAAgE;AAClE;;AAEA;IACI,WAAW;IACX,gEAAgE;AACpE;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4CAA4C;EAC5C,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,oDAAoD;EACpD,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;;;IAGE,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;;;IAGE,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;;;;;;IAME,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;AACF","sourcesContent":[".maincontent-physical {\n  display: flex;\n  padding-bottom: 1.5rem;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1 0 0;\n  align-self: stretch;\n}\n\n.toppart {\n  display: flex;\n  padding: 1.5rem;\n  padding-left: 2.5rem;\n  align-items: flex-start;\n  align-self: stretch;\n}\n\n.breadcrumb {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.3125rem;\n}\n\n.breadcrumb-element1 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.element-text {\n  color: var(--Grey-Grey-400, #bdbdbd);\n  font-family: Inter;\n  font-size: 0.75rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  letter-spacing: 0.01125rem;\n}\n\n.breadcrumb-element2 {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.625rem;\n}\n\n.overline {\n  color: var(--Grey-Grey-400, #bdbdbd);\n  font-family: Roboto;\n  font-size: 0.625rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  letter-spacing: 0.009375rem;\n}\n\n.breadcrumb-element3 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.element-text3 {\n  color: var(--Grey-Grey-800, #424242);\n  font-family: Inter;\n  font-size: 0.75rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  letter-spacing: 0.01125rem;\n}\n\n.mainpart-physical {\n  display: flex;\n  padding: 0rem 1.5rem;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n}\n\n.assessments {\n  display: flex;\n  padding-bottom: 12rem;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.5rem;\n  flex: 1 0 0;\n  align-self: stretch;\n}\n\n.frame-1 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.bar-tab {\n  display: flex;\n  width: 10.5rem;\n  height: 2.5rem;\n  max-width: 11.8125rem;\n  max-height: 3.5rem;\n  padding: 0.75rem 1rem;\n  justify-content: center;\n  gap: 0.5rem;\n  align-items: center;\n  border-radius: 8px;\n  border: 1px solid var(--Neutral-300, #cbd5e1);\n  background: var(--Neutral-50, #f8fafc);\n}\n\n.bar-tab-text {\n  color: var(--Neutral-700, #334155);\n  text-align: center;\n  font-feature-settings: \"liga\" off, \"clig\" off;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16px;\n}\n\n.bar-tab-active {\n  border-radius: 8px;\n  border: 1px solid var(--Primary-300, #74e1b4);\n  background: var(--Primary-50, #edfcf5);\n}\n.check-icon-inline {\n  width: 16px;\n  height: 32px;\n  margin-right: 6px;\n  vertical-align: middle;\n}\n.bar-tab-completed {\n  border-radius: 8px;\n  border: 1px solid var(--Primary-300, #74e1b4);\n  background: var(--Primary-50, #edfcf5);\n}\n\n.frame-2 {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.title-main {\n  color: var(--Neutral-950, #020618);\n  text-align: center;\n  font-family: Inter;\n  font-size: 1.25rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 2rem;\n}\n\n.subtitle-main {\n  color: var(--Neutral-700, #334155);\n  text-align: center;\n  font-family: Inter;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n}\n\n.frame-3 {\n  display: flex;\n  align-items: center;\n  border-radius: 0.5rem;\n  background: #fff;\n}\n\n.physical-image {\n  width: 41.625rem;\n  height: 18.5rem;\n}\n\n.frame-4 {\n  display: flex;\n  padding: 0.125rem 0.625rem;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.5rem;\n  border-radius: 9999px;\n  border: 1px solid #042a20;\n  background: #edfcf5;\n}\n\n.bedge-text {\n  color: var(--Neutral-950, #020618);\n  font-family: Inter;\n  font-size: 0.75rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.25rem;\n}\n\n.frame-5 {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2rem;\n}\n\n.button-physical {\n  display: flex;\n  height: 2.625rem;\n  padding: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  border-radius: 0.25rem;\n  border: 0.03125rem solid #0a5b42;\n  background: linear-gradient(180deg, #0c8f63 0%, #0a7253 103.57%);\n}\n\n.button-physical:hover {\n    width: 100%;\n    background: linear-gradient(180deg, #09704e 0%, #074f39 103.57%);\n}\n\n.button-text {\n  color: #f8fafc;\n  text-align: center;\n  font-family: var(--Label-Large-Font, Roboto);\n  font-size: var(--Label-Large-Size, 0.875rem);\n  font-style: normal;\n  font-weight: 500;\n  line-height: var(--Label-Large-Line-Height, 1.25rem);\n  letter-spacing: var(--Label-Large-Tracking, 0.00625rem);\n}\n\n.button-arrow {\n  width: 2rem;\n  height: 2rem;\n  aspect-ratio: 1/1;\n}\n\n@media (max-width: 1158px) {\n  .breadcrumb {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 0.25rem;\n    padding: 0.5rem;\n    text-align: center;\n  }\n\n  .breadcrumb-element1,\n  .breadcrumb-element2,\n  .breadcrumb-element3 {\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 0.25rem;\n  }\n\n  .element-text,\n  .element-text3,\n  .overline {\n    font-size: 0.65rem;\n    line-height: 1rem;\n    white-space: nowrap;\n  }\n\n  .toppart {\n    flex-direction: column;\n    padding: 1rem;\n    align-items: flex-start;\n    text-align: center;\n  }\n\n  .frame-3 {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 1rem;\n  }\n\n  .physical-image {\n    width: 100%;\n    height: auto;\n    max-width: 100%;\n    object-fit: contain;\n  }\n\n  .mainpart-physical,\n  .assessments,\n  .frame-1,\n  .frame-2,\n  .frame-4,\n  .frame-5 {\n    padding: 0 1rem;\n    align-items: center;\n    text-align: center;\n  }\n\n  .title-main {\n    font-size: 1.125rem;\n    line-height: 1.75rem;\n  }\n\n  .subtitle-main {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n  }\n\n  .bar-tag {\n    width: auto;\n    padding: 0.5rem 1rem;\n  }\n\n  .button-physical {\n    width: 100%;\n    max-width: 300px;\n  }\n}\n\n@media (max-width: 480px) {\n  .bedge-text{\n    font-size: 0.6rem;\n  }\n  .frame-1{\n    display: none;\n  }\n  .frame-2{\n    width:95vw;\n    padding-top: 1rem;\n    margin-left: 0.5rem;\n  }\n  .assessments{\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    overflow-y: scroll;\n  }\n  .Report-frame-3{\n    width: 100vw;\n    display: flex;\n    flex-direction: column;\n    padding-right: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
